import React from 'react';
import { Routes, Route, Link, useLocation } from 'react-router-dom';
// Removed: Button import, not needed without the video list view
import Header from './Header';
import Footer from './Footer';
import './App.css';
import './Header.css';
import './Footer.css';
// Removed all video-related imports (ComboPlayer, client, useYouTubeApi, VideoList, VideoPage)
// NOTE: Assuming your TrumpTracker component may need sanity-client, I will leave the file but remove its import/logic from here.
import TrumpTracker from './TrumpTracker';

function App() {
  // Removed all state and useEffect hooks related to videos
  
  return (
    <>
      <Header />
      <div className="main-container">
        <div className="main-content-wrapper">
          {/* Removed: isVideoPage check and conditional buttons */}
          
          <Routes>
            {/* The root path of this application will render the Trump Tracker */}
            <Route path="/" element={<TrumpTracker />} />
            {/* Removed: All video routes */}
          </Routes>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default App;